import { Link } from 'react-router-dom';
import CheckboxField from '../../../components/Input/checkbox-field';
import TextField from '../../../components/Input/text-field';
import ReactSelectField from '../../../components/Input/react-select-field';
import { UserInfo } from '../../../services/featureTogglesSlice';
import { useState } from 'react';

const EditImageTypeForm = ({ 
    name,
    setIsEnabled,
    isEnabled,   
    selectedUsers, 
    setSelectedUsers,
    readOnly,
    onSave,
    users
  }: any) => {  


const onUserChange = (selectedItems: any) => {                  
      setSelectedUsers(selectedItems);
    };

    const userOptions = users?.map((user: UserInfo) => { return { 
            value: user.id, 
            label: user.name + " (" + user.emailAddress + ")", 
            }
          });

    return (
            <div className="columns">
              <div className="column is-one-quarter">
                <h4>{name}</h4>
                <CheckboxField
                  label="Enabled"                   
                  checked={isEnabled} 
                  onChange={setIsEnabled}
                  readOnly={readOnly} />
                <div className="mt-1">
                  <ReactSelectField  label="Enabled Users" options={userOptions} value={selectedUsers} onChange={onUserChange} isMulti={true} />
                </div>
                
                <div className="field is-grouped mt-3">
                    <div className="control">
                        <Link className='button' to={`/admin/feature-toggles/list`}>Cancel</Link>
                    </div>
                    {!readOnly && 
                        <div className="control">
                            <button className="button is-link" type="submit" onClick={onSave}>Save</button>
                        </div>        
                    }                          
                </div>
              </div>             
        </div>
    )    
};

export default EditImageTypeForm;